<template>
   <v-dialog v-model="modal" persistent max-width="70vh">
      <v-card>
         <v-row no-gutters>
            <v-toolbar dense class="primary white--text">
               <v-toolbar-title>Students</v-toolbar-title>
               <v-spacer></v-spacer>
               <v-btn class="mx-2" @click.stop="cancelBtnClick">Cancel</v-btn>
               <v-btn class="mx-2" @click.stop="okBtnClick">OK</v-btn>
            </v-toolbar>
            <v-card>
               <v-text-field
                  class="px-2 py-2"
                  v-model="student_search"
                  label="Search"
                  placeholder="Search"
                  single-line
                  hide-details
                  clearable
               ></v-text-field>
               <v-data-table
                  class="px-2"
                  height="60vh"
                  dense
                  fixed-header
                  v-model="selectedstudent"
                  :headers="studentheaders"
                  :items="studentlist"
                  @click:row="rowClick"
                  item-key="school_id"
                  :search="student_search"
                  single-select
               >
               </v-data-table>
            </v-card>
         </v-row>
      </v-card>
   </v-dialog>
</template>

<script>
   export default {
      inject: ["ShowMessage"],

      data() {
         return {
            modal: false,
            selectedstudent: [],
            student_search: "",
            studentlist: [],
            studentheaders: [
               {
                  text: "Code",
                  value: "student_code",
                  width: "10vh",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Name",
                  value: "student_fullname",
                  width: "24vh",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Gender",
                  value: "gendertext",
                  width: "9vh",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Year",
                  value: "ncyear",
                  width: "9vh",
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
         };
      },

      methods: {
         rowClick(item, row) {
            row.select(!row.isSelected);
         },

         open() {
            this.selectedstudent.splice(0);

            this.loadStudentList();
            this.modal = true;
            return new Promise((resolve, reject) => {
               this.resolve = resolve;
               this.reject = reject;
            });
         },

         async loadStudentList() {
            await this.$http({
               url: "/cca/getccastudentlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.studentlist = response.data.studentdata;
                  }
               }
            });
         },
         cancelBtnClick() {
            this.resolve(false);
            this.modal = false;
         },

         okBtnClick() {
            this.resolve(true);
            this.modal = false;
            this.$emit("save-selection", this.selectedstudent[0]);
         },
      },
   };
</script>
